var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "icon",
    class: "icon-".concat(_vm.icon)
  }), _c('div', {
    staticClass: "image",
    class: "image-".concat(_vm.image)
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": ""
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }